import { AccessPaths, AppPaths } from '@ftr/routing-paths'
import { SideNavGroup, SideNavItem } from './side-nav-item'

const ACCESS_TRANSCRIPT_JOBS_ITEM: SideNavItem = {
  type: 'LINK',
  icon: 'AccessTranscriptJobs',
  title: 'Transcript Jobs',
  path: [AppPaths.Jobs],
}

export const getAccessNavItemsGroup = (hasTranscriberPermissions = false): SideNavGroup => ({
  title: 'Access',
  items: [
    {
      type: 'LINK',
      icon: 'Content',
      title: 'Content',
      path: [AppPaths.Access, AccessPaths.Content],
    },
    {
      type: 'LINK',
      icon: 'Requests',
      title: 'Requests',
      path: [AppPaths.Access, AccessPaths.Requests],
    },
    ...(hasTranscriberPermissions ? [ACCESS_TRANSCRIPT_JOBS_ITEM] : []),
  ],
})
